'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DateTimeWindowsIterator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Status = require('./Status');

var Status = _interopRequireWildcard(_Status);

var _DateTimeWindowsUtils = require('./DateTimeWindowsUtils');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateTimeWindowsIterator = exports.DateTimeWindowsIterator = function () {
    /**
     * @param timeWindows   List<DateTimeWindow>
     * @param cal           Moment with tz
     */
    function DateTimeWindowsIterator(_ref) {
        var _this = this;

        var _ref$timeWindows = _ref.timeWindows,
            timeWindows = _ref$timeWindows === undefined ? [] : _ref$timeWindows,
            cal = _ref.cal;

        _classCallCheck(this, DateTimeWindowsIterator);

        this._tz = cal.tz();
        timeWindows = timeWindows || []; // null timeWindows is supported, equivalent to empty timeWindows

        var calValue = cal.valueOf();
        timeWindows = _lodash2.default.filter(timeWindows, function (win) {
            var endTime = (0, _DateTimeWindowsUtils.getTime)(win.end, _this._tz);
            return endTime === null || endTime > calValue;
        });

        this._timeWindows = (0, _DateTimeWindowsUtils.normalize)(timeWindows);

        this._index = null;
        this._lastWindowUntilForever = null;
        if (this._timeWindows.length > 0) {
            this._index = (0, _DateTimeWindowsUtils.findInsertionIndex)(this._timeWindows, cal.valueOf(), this._tz);
            this._lastWindowUntilForever = !this._timeWindows[this._timeWindows.length - 1].end;
        } else {
            this._index = new _DateTimeWindowsUtils.Index(0, true);
            this._lastWindowUntilForever = false;
        }
    }

    /** @return Boolean */


    _createClass(DateTimeWindowsIterator, [{
        key: 'hasNext',
        value: function hasNext() {
            if (this._index.index < this._timeWindows.length) {
                return true;
            }

            return this._index.isDummyBefore && !this._lastWindowUntilForever;
        }

        /** @return Status */

    }, {
        key: 'next',
        value: function next() {
            var result = void 0;

            if (this._index.index === this._timeWindows.length) {
                result = {
                    status: Status.STATUS_UNKNOWN,
                    until: null
                };
            } else {
                var nextTimeWindow = this._timeWindows[this._index.index];
                if (!this._index.isDummyBefore) {
                    result = {
                        status: nextTimeWindow.available ? Status.STATUS_AVAILABLE : Status.STATUS_UNAVAILABLE,
                        until: (0, _DateTimeWindowsUtils.getTime)(nextTimeWindow.end, this._tz),
                        reason: nextTimeWindow.reason,
                        comment: nextTimeWindow.comment
                    };
                } else {
                    result = {
                        status: Status.STATUS_UNKNOWN,
                        until: (0, _DateTimeWindowsUtils.getTime)(nextTimeWindow.start, this._tz)
                    };
                }
            }

            this._index.advance();
            return result;
        }
    }]);

    return DateTimeWindowsIterator;
}();


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/iterators/DateTimeWindowsIterator.js
// module id = 876
// module chunks = 0